import React from 'react';
import { Modal } from '@tw/tw-component-library';
import { SectionKey, sectionKeyToDisplay } from '../../../types';
import { StyledComponents } from './FormStack.styles';

const { CompletionModalContent } = StyledComponents;

export interface FormCompletionModalProps {
  isOpen: boolean;
  completedDate?: string;
  onClose?: () => void;
  onGoToDashboard: () => void;
  onStartNew: () => void;
  isSingleSection?: boolean;
  isRejected: boolean;
  sectionFlow: SectionKey[];
}

export const FormCompletionModal = React.memo(
  ({
    isOpen,
    completedDate,
    onClose,
    onGoToDashboard,
    onStartNew,
    isSingleSection,
    isRejected,
    sectionFlow,
  }: FormCompletionModalProps) => (
    <Modal
      isOpen={isOpen}
      onClose={onClose ?? onGoToDashboard}
      title={isRejected ? 'Form Rejected' : 'Form Completed'}
      size="medium"
    >
      <CompletionModalContent>
        <div className="completion-modal-content">
          <h3>
            {isRejected
              ? 'Form has been rejected!'
              : 'Form completed successfully!'}
          </h3>
          <p>
            {isRejected ? 'Rejected on:' : 'Completed on:'}{' '}
            {completedDate ? new Date(completedDate).toLocaleString() : ''}
          </p>
          {!isSingleSection && (
            <div className="completion-summary">
              {sectionFlow.map((section) => (
                <div key={section} className="section-status">
                  <span>{sectionKeyToDisplay[section] ?? section}</span>
                  <span>{isRejected ? '❌' : '✅'}</span>
                </div>
              ))}
            </div>
          )}
          <div className="action-buttons">
            <button onClick={onStartNew}>Start New Form</button>
            <button onClick={onGoToDashboard}>Close</button>
          </div>
        </div>
      </CompletionModalContent>
    </Modal>
  )
);
